module.exports = __webpack_public_path__ + "static/media/ventil_bild.d1fe3a0c.jpg";